import { Car } from '../../types/generated';
import { apiMutate } from '../../utils/mutation';
import { addCarMutation } from '../../mutations/car';
import ServiceConfigs from '../../config';
import { useCarBook } from '.';

type UseAddCarType = () => ({
  make,
  color,
  licenseNumber,
}: {
  make: string;
  color: string;
  licenseNumber?: string;
}) => Promise<Partial<Car>>;

const useAddCar: UseAddCarType = () => {
  const { data: carsBook, mutate: mutateCarsBook } = useCarBook();
  return variables =>
    apiMutate({
      mutation: addCarMutation,
      variables: { ...variables },
      requestHeaders: { ...ServiceConfigs.getAuthorizationHeader() },
      handler: (res: any) => res?.addCar,
    }).then(car => {
      mutateCarsBook([...carsBook, car], false);
      return car;
    });
};
export default useAddCar;
